"use strict";

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Modal = require("react-modal");
var HistoryHeader_1 = require("./HistoryPopup/HistoryHeader");
var HistoryItems_1 = require("./HistoryPopup/HistoryItems");
var CustomGraphiQL_1 = require("./GraphiQL/CustomGraphiQL");
var graphcool_styles_1 = require("graphcool-styles");
var constants_1 = require("./constants");
var HistoryPopup = function (_super) {
    __extends(HistoryPopup, _super);
    function HistoryPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.handleItemSelect = function (index) {
            _this.setState({ selectedItemIndex: index });
        };
        _this.handleSelectFilter = function (filter) {
            _this.setState({ selectedFilter: filter });
        };
        _this.handleSearch = function (term) {
            _this.setState({ searchTerm: term });
        };
        _this.state = {
            selectedFilter: 'HISTORY',
            selectedItemIndex: 0,
            searchTerm: ''
        };
        return _this;
    }
    HistoryPopup.prototype.render = function () {
        var _this = this;
        var _a = this.state,
            searchTerm = _a.searchTerm,
            selectedFilter = _a.selectedFilter;
        var items = this.props.historyItems.filter(function (item) {
            return selectedFilter === 'STARRED' ? item.starred : true && (searchTerm && searchTerm.length > 0 ? item.query.toLowerCase().includes(searchTerm.toLowerCase()) : true);
        });
        var selectedItem = items[this.state.selectedItemIndex];
        var schema = selectedItem ? this.props.schemas[selectedItem.selectedEndpoint] : null;
        return React.createElement(
            Modal,
            { isOpen: this.props.isOpen, onRequestClose: this.props.onRequestClose, contentLabel: "GraphiQL Session History", style: constants_1.modalStyle },
            React.createElement(_style2.default, {
                styleId: 1186519991,
                css: ".history-popup[data-jsx=\"1186519991\"] {min-height: 500px;}.left[data-jsx=\"1186519991\"][data-jsx=\"1186519991\"]:after {content: \"\";position: absolute;bottom: 0px;height: 50px;left: 0;right: 0;width: 100%;background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0%,rgba(255, 255, 255, 1) 100%);background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%,rgba(255, 255, 255, 1) 100%);}.right[data-jsx=\"1186519991\"] {-moz-flex: 0 0 464px;-webkit-box-flex: 0;-ms-flex: 0 0 464px;flex: 0 0 464px;}.right-header[data-jsx=\"1186519991\"] {padding-top: 20px;padding-bottom: 20px;}.flex,\n.history-popup[data-jsx=\"1186519991\"],\n.right-header[data-jsx=\"1186519991\"],\n.right-empty[data-jsx=\"1186519991\"],\n.use[data-jsx=\"1186519991\"] {display: -ms-flexbox;display: flex;}.flex1,\n.left[data-jsx=\"1186519991\"] {-ms-flex: 1;flex: 1;}.flex1,\n.flexAuto,\n.left[data-jsx=\"1186519991\"] {min-width: 0;min-height: 0;}.bgWhite,\n.left[data-jsx=\"1186519991\"] {background-color: #fff;}.z2,\n.right[data-jsx=\"1186519991\"] {z-index: 2;}.justifyBetween,\n.right-header[data-jsx=\"1186519991\"] {-ms-flex-pack: justify;justify-content: space-between;}.flex,\n.history-popup[data-jsx=\"1186519991\"],\n.right-header[data-jsx=\"1186519991\"],\n.right-empty[data-jsx=\"1186519991\"],\n.use[data-jsx=\"1186519991\"] {display: -ms-flexbox;display: flex;}.bgDarkBlue,\n.right-header[data-jsx=\"1186519991\"],\n.right-empty[data-jsx=\"1186519991\"] {background-color: #172a3a;}.itemsCenter,\n.right-header[data-jsx=\"1186519991\"],\n.right-empty[data-jsx=\"1186519991\"],\n.use[data-jsx=\"1186519991\"] {-webkit-box-align: center;-ms-flex-align: center;-ms-grid-row-align: center;align-items: center;}.ph25,\n.right-header[data-jsx=\"1186519991\"] {padding-left: 25px;padding-right: 25px;}.bgDarkBlue,\n.right-header[data-jsx=\"1186519991\"],\n.right-empty[data-jsx=\"1186519991\"] {background-color: #172a3a;}.h100,\n.right-empty[data-jsx=\"1186519991\"] {height: 100%;}.flex,\n.history-popup[data-jsx=\"1186519991\"],\n.right-header[data-jsx=\"1186519991\"],\n.right-empty[data-jsx=\"1186519991\"],\n.use[data-jsx=\"1186519991\"] {display: -ms-flexbox;display: flex;}.justifyCenter,\n.right-empty[data-jsx=\"1186519991\"] {-ms-flex-pack: center;justify-content: center;}.itemsCenter,\n.right-header[data-jsx=\"1186519991\"],\n.right-empty[data-jsx=\"1186519991\"],\n.use[data-jsx=\"1186519991\"] {-webkit-box-align: center;-ms-flex-align: center;-ms-grid-row-align: center;align-items: center;}.f16,\n.right-empty-text[data-jsx=\"1186519991\"] {font-size: 16px;}.white60,\n.right-empty-text[data-jsx=\"1186519991\"] {color: hsla(0,0%,100%,.6);}.f14,\n.view[data-jsx=\"1186519991\"],\n.use[data-jsx=\"1186519991\"] {font-size: 14px;}.white40,\n.view[data-jsx=\"1186519991\"] {color: hsla(0,0%,100%,.4);}.ttu,\n.view[data-jsx=\"1186519991\"] {text-transform: uppercase;}.fw6,\n.view[data-jsx=\"1186519991\"],\n.use[data-jsx=\"1186519991\"] {font-weight: 600;}.f14,\n.view[data-jsx=\"1186519991\"],\n.use[data-jsx=\"1186519991\"] {font-size: 14px;}.fw6,\n.view[data-jsx=\"1186519991\"],\n.use[data-jsx=\"1186519991\"] {font-weight: 600;}.pv10,\n.use[data-jsx=\"1186519991\"] {padding-top: 10px;padding-bottom: 10px;}.ph16,\n.use[data-jsx=\"1186519991\"] {padding-left: 16px;padding-right: 16px;}.bgGreen,\n.use[data-jsx=\"1186519991\"] {background-color: #27ae60;}.flex,\n.history-popup[data-jsx=\"1186519991\"],\n.right-header[data-jsx=\"1186519991\"],\n.right-empty[data-jsx=\"1186519991\"],\n.use[data-jsx=\"1186519991\"] {display: -ms-flexbox;display: flex;}.br2,\n.use[data-jsx=\"1186519991\"] {border-radius: 2px;}.itemsCenter,\n.right-header[data-jsx=\"1186519991\"],\n.right-empty[data-jsx=\"1186519991\"],\n.use[data-jsx=\"1186519991\"] {-webkit-box-align: center;-ms-flex-align: center;-ms-grid-row-align: center;align-items: center;}.pointer:hover,\n.use[data-jsx=\"1186519991\"]:hover {cursor: pointer;}.mr6,\n.use-text[data-jsx=\"1186519991\"] {margin-right: 6px;}.white,\n.use-text[data-jsx=\"1186519991\"] {color: #fff;}"
            }),
            React.createElement(
                "div",
                { className: "history-popup", "data-jsx": 1186519991
                },
                React.createElement(
                    "div",
                    { className: "left", "data-jsx": 1186519991
                    },
                    React.createElement(HistoryHeader_1.default, { onSelectFilter: this.handleSelectFilter, selectedFilter: this.state.selectedFilter, onSearch: this.handleSearch }),
                    React.createElement(HistoryItems_1.default, { items: items, selectedItemIndex: this.state.selectedItemIndex, searchTerm: this.state.searchTerm, onItemSelect: this.handleItemSelect, onItemStarToggled: this.props.onItemStarToggled })
                ),
                Boolean(selectedItem) ? React.createElement(
                    "div",
                    { className: "right", "data-jsx": 1186519991
                    },
                    React.createElement(
                        "div",
                        { className: "right-header", "data-jsx": 1186519991
                        },
                        React.createElement(
                            "div",
                            { className: "view", "data-jsx": 1186519991
                            },
                            selectedItem.selectedEndpoint + " API / View as " + selectedItem.selectedViewer
                        ),
                        React.createElement(
                            "div",
                            { className: "use", onClick: function onClick() {
                                    _this.props.onCreateSession(selectedItem);
                                    _this.props.onRequestClose();
                                }, "data-jsx": 1186519991
                            },
                            React.createElement(
                                "div",
                                { className: "use-text", "data-jsx": 1186519991
                                },
                                "Use"
                            ),
                            React.createElement(graphcool_styles_1.Icon, { src: require('./assets/icons/arrowRight.svg'), color: graphcool_styles_1.$v.white, stroke: true, width: 13, height: 13 })
                        )
                    ),
                    React.createElement(CustomGraphiQL_1.CustomGraphiQL, { schema: schema, variables: selectedItem.variables, query: selectedItem.query, fetcher: this.props.fetcherCreater(selectedItem), disableQueryHeader: true, queryOnly: true, rerenderQuery: true })
                ) : React.createElement(
                    "div",
                    { className: "right", "data-jsx": 1186519991
                    },
                    React.createElement(
                        "div",
                        { className: "right-empty", "data-jsx": 1186519991
                        },
                        React.createElement(
                            "div",
                            { className: "right-empty-text", "data-jsx": 1186519991
                            },
                            "No History yet"
                        )
                    )
                )
            )
        );
    };
    return HistoryPopup;
}(React.Component);
exports.default = HistoryPopup;


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/HistoryPopup.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/HistoryPopup.js
// module chunks = 0